module.exports = __webpack_public_path__ + "assets/img/05.4bee6b36.png";